/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ActivewearInputs */

const en_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activewear`)
};

const es_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ropa deportiva`)
};

const fr_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vêtements de sport`)
};

const de_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sportbekleidung`)
};

const ja_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブウェア`)
};

const zh_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`运动服`)
};

const ar_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملابس رياضية`)
};

const id_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakaian Olahraga`)
};

const it_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbigliamento Sportivo`)
};

const ru_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Спортивная одежда`)
};

const pt_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roupas Esportivas`)
};

const ko_val_activewear = /** @type {(inputs: Val_ActivewearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스포츠웨어`)
};

/**
* | output |
* | --- |
* | "Activewear" |
*
* @param {Val_ActivewearInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_activewear = /** @type {((inputs?: Val_ActivewearInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ActivewearInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_activewear(inputs)
	if (locale === "es") return es_val_activewear(inputs)
	if (locale === "fr") return fr_val_activewear(inputs)
	if (locale === "de") return de_val_activewear(inputs)
	if (locale === "ja") return ja_val_activewear(inputs)
	if (locale === "zh") return zh_val_activewear(inputs)
	if (locale === "ar") return ar_val_activewear(inputs)
	if (locale === "id") return id_val_activewear(inputs)
	if (locale === "it") return it_val_activewear(inputs)
	if (locale === "ru") return ru_val_activewear(inputs)
	if (locale === "pt") return pt_val_activewear(inputs)
	return ko_val_activewear(inputs)
});